import { CurrentUser } from '../../types';
import { Action } from '../../types/Action';

export enum CurrentUserActionType {
  SET_CURRENT_USER = 'SET_CURRENT_USER',
  SET_PERMISSIONS = 'SET_PERMISSIONS',
  SET_CURRENT_DEAL_TYPE = 'SET_CURRENT_DEAL_TYPE',
  SET_SHOW_RELEASE_NOTES = 'SET_SHOW_RELEASE_NOTES',
  SET_CURRENT_DEALER = 'SET_CURRENT_DEALER',
  SET_CURRENT_STORE_CODE = 'SET_CURRENT_STORE_CODE',
}

export const setCurrentUserAction = (salesPersons: CurrentUser): Action => ({
  type: CurrentUserActionType.SET_CURRENT_USER,
  payload: salesPersons,
});

export const setPermissionsAction = (permissions: any[]): Action => ({
  type: CurrentUserActionType.SET_PERMISSIONS,
  payload: permissions,
});

export const setCurrentDealTypeAction = (dealerInfos: string): Action => ({
  type: CurrentUserActionType.SET_CURRENT_DEAL_TYPE,
  payload: dealerInfos,
});

export const setShowReleaseNotesAction = (value: boolean): Action => ({
  type: CurrentUserActionType.SET_SHOW_RELEASE_NOTES,
  payload: value,
});

export const setCurrentDealerIdAction = (value: string): Action => ({
  type: CurrentUserActionType.SET_CURRENT_DEALER,
  payload: value,
});

export const setCurrentStoreCodeAction = (value: string): Action => ({
  type: CurrentUserActionType.SET_CURRENT_STORE_CODE,
  payload: value,
});

export type CurrentUserActions = ReturnType<
  | typeof setCurrentUserAction
  | typeof setPermissionsAction
  | typeof setCurrentDealTypeAction
  | typeof setShowReleaseNotesAction
  | typeof setCurrentDealerIdAction
  | typeof setCurrentStoreCodeAction
>;
